export default {
  events: [{
      id: 'abc-123',
      name: 'London Gatwick, England',
      lat: 51.5286416,
      lng: -0.1015987,
      depart: '2017-09-01',
      start: true,
      to: [{
        type: 'flight',
        departFrom: 'London, Gatwick',
        terminal: 'South Terminal',
        departureDate: '2017-10-02',
        departureTime: '09:25',
        flightNumber: 'BA2169',
        arriveAt: 'Fort Lauderdale, Miami',
        arrivalTime: '13:45',
      }, ],
    },
    {
      id: 'rio-2323ee',
      name: 'Rio de Janeiro, Brazil',
      lat: -22.0622487,
      lng: -44.0448167,
      arrive: '2017-09-08',
      itinerary: [{
          date: '2017-12-29',
          descr: 'TBC',
        },
        {
          date: '2017-12-30',
          descr: 'Hotel 55 Rio',
        },
        {
          date: '2017-12-31',
          descr: 'New Years Eve; Hotel 55 Rio',
        },
        {
          date: '2018-01-01',
          descr: 'New Years Day; Hotel 55 Rio',
        },
        {
          date: '2018-01-02',
          descr: 'Hotel 55 Rio',
        },
        {
          date: '2018-01-03',
          descr: 'Fly home',
        },
      ],
      to: [{
        type: 'flight',
        departFrom: 'Rio De Janeiro',
        terminal: '',
        departureDate: '2017-01-03',
        departureTime: '23:00',
        flightNumber: '',
        arriveAt: 'London Gatwick',
        arrivalTime: '12:10',
      }, ],
    },
    {
      id: 'abc-1218',
      name: 'London Gatwick',
      lat: 51.5286416,
      lng: -0.1015987,
      arrive: '2018-01-03',
      end: true,
    },
  ],

  media: {

  }
}



// WEBPACK FOOTER //
// ./src/temp/otherTripData.js